import {infiniteQueryOptions, queryOptions} from '@tanstack/react-query';
import {fetchGuide} from './fetchGuide';
import {FetchGuideParams, fetchGuides} from './fetchGuides';
import {fetchGuidesCount} from './fetchGuidesCount';

export const guideQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['guides', {id}],
    queryFn: () => fetchGuide(id),
  });

export const guidesQueryOptions = (params: FetchGuideParams) =>
  queryOptions({
    queryKey: ['guides', {params}],
    queryFn: () => fetchGuides(params),
  });

export const guidesCountQueryOptions = () =>
  queryOptions({
    queryKey: ['guides-count'],
    queryFn: fetchGuidesCount,
  });

export const guidesInfiniteQueryOptions = (params: Omit<FetchGuideParams, 'page'>) =>
  infiniteQueryOptions({
    queryKey: ['guides-infinite', {params}],
    queryFn: async ({pageParam = 1}) => fetchGuides({...params, page: pageParam}),
    getNextPageParam: (lastPage) => {
      const lastPageNumber = lastPage.pagination.page;
      const isLastPage =
        lastPage.pagination.total - lastPage.pagination.page * lastPage.pagination.take <= 0;
      return isLastPage ? undefined : lastPageNumber + 1;
    },
    initialPageParam: 1,
  });
